import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserRound } from "lucide-react";
import { api, fetchVolunteerAnalytics } from "../lib/api";
import { HERO_HOME } from "../lib/volunteerVisuals";
import { PageHero } from "../components/community/PageParts";
import { MetricsGrid, CategoryRanking, ActionHeatMap } from "../components/action/ActionParts";
import { Leaderboards, TopOrganizations, TrendCharts } from "../components/action/ActionCharts";
import { VolunteerDashboard } from "../components/volunteer/VolunteerDashboard";

const PERIODS = [[7, "Past 7 days"], [30, "Past 30 days"], [90, "Past 90 days"], [365, "Past year"]];

export default function ActionIndex() {
  const [period, setPeriod] = useState(30);
  const [d, setD] = useState(null);
  const [a, setA] = useState(null);
  const [metric, setMetric] = useState("all");
  useEffect(() => { fetchVolunteerAnalytics().then(setA).catch(() => {}); }, []);
  useEffect(() => { setD(null); api.get("/action-index", { params: { period } }).then((r) => setD(r.data)).catch(() => {}); }, [period]);
  return (
    <div data-testid="action-index-page">
      <PageHero eyebrow="Action Index™" title="Be the Change" img={HERO_HOME} alt="Volunteers working together outdoors" testId="action-index-hero"
        sub="Explore opportunities where community members are taking action.">
        <Link to="/volunteer" className="btn-green mr-3 mt-8 inline-flex items-center rounded-full px-5 py-2.5 text-sm font-semibold" data-testid="action-index-create-ripple">Create a Ripple</Link>
        <Link to="/my-actions" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[#1E3A8A]" data-testid="action-index-my-actions-link"><UserRound size={16} />My Actions</Link>
      </PageHero>
      <div className="mx-auto max-w-7xl space-y-6 px-5 py-10 sm:px-8">
        <div className="flex flex-wrap gap-2" data-testid="period-toggle">
          {PERIODS.map(([p, l]) => (
            <button key={p} onClick={() => setPeriod(p)} aria-pressed={period === p} data-testid={`period-${p}`}
              className={`rounded-full border px-4 py-2 text-sm font-semibold ${period === p ? "border-[#1E3A8A] bg-[#1E3A8A] text-white" : "border-slate-300 bg-white text-slate-700"}`}>{l}</button>
          ))}
        </div>
        {!d ? <div className="h-96 animate-pulse rounded-3xl bg-white" /> : (
          <>
            <MetricsGrid m={d.metrics} cats={d.categories} />
            <TrendCharts trend={d.trend} momentum={d.momentum} typeMomentum={d.type_momentum} />
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:items-start"><CategoryRanking cats={d.categories} /><ActionHeatMap provinces={d.provinces} metric={metric} setMetric={setMetric} /></div>
            <Leaderboards boards={d.leaderboards} cats={d.categories} />
            <TopOrganizations orgs={d.organizations} />
          </>
        )}
        <section className="pt-6"><h2 className="mb-4 text-2xl font-bold tracking-tight text-slate-900">Available opportunities</h2><VolunteerDashboard a={a} /></section>
        <p className="text-xs text-slate-600">Counts come from visitors tapping Interested or Attended — one count per browser per listing, no accounts and no personal data. RippleImpact measures participation, not estimated impact.</p>
      </div>
    </div>
  );
}
